import React, { useState } from "react";
import { FaLungs } from "react-icons/fa6"; // better for TB theme

const DEFAULT_TB_DATA = {
  presumptiveCases: { value: 982341, percent: 78.3 },
  testedCases: { value: 812567, percent: 82.7 },
  confirmedTB: { value: 204531, percent: 25.1 },
  drugSensitive: { value: 183420, percent: 89.7 },
  drugResistant: { value: 21111, percent: 10.3 },
  onTreatment: { value: 95362, percent: 95.5 },
  treatmentCompleted: { value: 54872, percent: 79.3 },
};

export default function TBDataCard({ selectedDistrict = null }) {
  const [open, setOpen] = useState(false);

  // Scale data for district-level view
  const data = selectedDistrict
    ? Object.fromEntries(
      Object.entries(DEFAULT_TB_DATA).map(([key, val]) => [
        key,
        {
          value: Math.round(val.value * 0.15),
          percent: val.percent,
        },
      ])
    )
    : DEFAULT_TB_DATA;
  const current = data.onTreatment.value;

  // Last month dummy value = 10% less
  const lastMonth = Math.round(current * 0.9);

  const diff = current - lastMonth;
  const percentChange = Math.round((diff / lastMonth) * 100);
  return (
    <>
      {/* Small Card */}
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-3 px-3 py-2 rounded-lg shadow-sm bg-white border hover:shadow-md w-full transition-all"
      >
        <div className="w-10 h-10 flex items-center justify-center rounded-md bg-teal-100">
          <FaLungs className="text-teal-600 w-5 h-5" />
        </div>

        <div className="text-left">
          <div className="text-xs text-slate-600 font-medium">
            Live TB Patient Count
          </div>
          <div className="text-lg font-semibold text-slate-800">
            {data.onTreatment.value.toLocaleString('en-IN')}
          </div>
          <div className="text-[11px] mt-0.5">
            <span className="text-green-600">
              ▲ {Math.abs(percentChange)}%
            </span>
            <span className="text-slate-500"> vs last month</span>
          </div>
        </div>
      </button>

      {/* Offcanvas */}
      {open && (
        <div className="fixed inset-0 z-50 flex">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setOpen(false)}
          />

          {/* Panel */}
          <aside className="relative ml-auto w-full max-w-md h-full bg-white shadow-2xl overflow-auto">
            <div className="p-4 border-b flex items-center justify-between">
              <h3 className="text-lg font-semibold">
                Tuberculosis (TB) Program Data
              </h3>
              <button
                onClick={() => setOpen(false)}
                className="px-3 py-1 rounded bg-slate-100 text-sm hover:bg-slate-200"
              >
                Close
              </button>
            </div>

            <div className="p-4 space-y-4">
              {[
                { label: "Notified TB patients on ATT", data: data.presumptiveCases },
                { label: "Presumptive TB cases identified", data: data.testedCases },
                { label: "Presumptive TB cases sent for testing", data: data.confirmedTB },
                { label: "Presumptive TB sent for testing (within facility)", data: data.drugSensitive },
                { label: "Presumptive TB sent for testing (outside facility)", data: data.drugResistant },
                { label: "Tested for TB (within facility)", data: data.onTreatment },
                { label: "Tested for TB (outside facility)", data: data.treatmentCompleted },
                { label: "Diagnosed TB patients", data: data.drugSensitive },
                { label: "TB patients on treatment support", data: data.drugResistant },
                { label: "Beneficiaries registered at ICTC", data: data.onTreatment },
                { label: "ICTC-registered presumptive TB cases referred for testing", data: data.treatmentCompleted },
              ].map((item) => (
                <div key={item.label}>
                  <div className="flex justify-between items-center mb-1">
                    <span className="text-sm font-medium text-slate-700">
                      {item.label}
                    </span>
                    <span className="text-sm font-semibold text-slate-900">
                      {item.data.value.toLocaleString('en-IN')}
                      {item.data.percent ? ` (${item.data.percent}%)` : ""}
                    </span>
                  </div>
                  {item.data.percent && (
                    <div className="w-full bg-slate-200 rounded-full h-2">
                      <div
                        className="bg-teal-600 h-2 rounded-full"
                        style={{ width: `${item.data.percent}%` }}
                      ></div>
                    </div>
                  )}
                </div>
              ))}

              <div className="mt-3 text-xs text-slate-500">
                Source:  HMIS (Apr 2024 – Mar 2025)
              </div>
            </div>
          </aside>
        </div>
      )}
    </>
  );
}
